export default {
  // Acciones genéricas (botones de formulario/diálogo)
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  edit: 'Edit',
  back: 'Back',

  // Respuestas genéricas de sí/no/no aplica
  yes: 'Yes',
  no: 'No',
  na: 'N/A',

  // Estado de carga
  loading: 'Loading...',
  loading_locations: 'Loading Locations...',
  loading_map: 'Loading Map...',

  // Mensajes genéricos de UI
  'pull-message': 'Drag to update',

  // Campos genéricos de entidad (nombre, ubicación, rol, etc.)
  name: 'Name',
  location: 'Location',
  role: 'Role',
  roles: 'Roles',
  user: 'User',
  users: 'Users',
  franchise: 'Business Unit',
  organization: 'Organization',
  password: 'Password',
  password_placeholder: 'Enter your password',

  // Nombres de roles administrativos (selector de roles compartido)
  organization_admin: 'Organization Administrator',
  franchise_admin: 'Business Unit Administrator',
  franchise_supervisor: 'Business Unit Supervisor',
  users_admin: 'Users Administrator',
  password_manager: 'Password Manager',

  // Selectores de ubicaciones y organización
  zero_locations: 'No Locations.',
  locations_selected: 'Selected locations',
  all_organization: 'The Whole Organization',
  // Jerarquía de nodos (árbol de roles)
  role_info: 'Are you sure you want to delete the node and all its descendants?',
  updated_node: 'Update Node',

  // Selector genérico de grupo/ítem (formularios)
  group: 'Group',
  item: 'Item',

  // Notificaciones desde mixins globales
  camera_priority_notification_title: 'Binnacle',
  camera_priority_notification_body: 'Taking photo…',
  camera_unavailable: 'This device does not have a camera available.',
  pick_image_source_title: 'Select Image',
  pick_image_source_message: 'Select the image source to use.',
  pick_image_source_camera: 'Camera',
  pick_image_source_files: 'Files',

  // Alcance de permisos (organización completa / unidad de negocio / propios)
  scope_organization: 'Organization',
  scope_franchise: 'Business Unit',
  scope_own: 'Own',

  // Campos de dirección y contacto (franquicias/ubicaciones)
  rfc: 'RFC',
  address: 'Address',
  folio: 'Folio',
  longitude: 'Longitude',
  latitude: 'Latitude',
  timezone: 'Time zone',
  timezone_adjusted: 'Time zone updated. {events} agenda activities and {tasks} tasks of this location will be adjusted.',
  contact_number: 'Contact telephone',

  // Gestión de grupos de ubicaciones
  add_group: 'Add Group',
  add_group_prompt: 'Enter the name of the group you want to create',
  delete_group_prompt: 'Do you want to delete the group "{group_name}"?',
  delete_location_title: 'Delete location',
  delete_location_prompt: 'Do you want to delete the location "{location_name}"?',
  delete_location_has_data: 'The location "{location_name}" has related information ({details}). Deleting it will hide it from the platform, but the information is preserved.',
  delete_location_continue: 'Do you want to continue?',
  related_assigned_users: 'Assigned users: {count}',
  related_occurrences: 'Reviews: {count}',
  related_events: 'Calendar events: {count}',
  related_tasks: 'Tasks: {count}',
  add_subgroup: 'Add subgroup',
  add_subgroup_in: 'Add subgroup in "{group_name}"',
  focus_group: 'Focus this branch',
  all_groups: 'All groups',
  level_n: 'Level {level}',
  sort_groups: 'Sort',
  sort_alpha_asc: 'Alphabetical (A-Z)',
  sort_alpha_desc: 'Alphabetical (Z-A)',
  sort_custom: 'Manual (drag)',
  sort_alpha_asc_short: 'A-Z',
  sort_alpha_desc_short: 'Z-A',
  sort_custom_short: 'Manual',
  sort_level_hint: 'The order applies to every group at this level in the organization',
  sort_order_updated: 'Order updated',
  sort_type_updated: 'The level sort type was updated',
  sort_custom_required: 'Switch this level to manual order before dragging',
  locations: 'Locations',
  unit: 'Add Business Unit',

  // Formulario/widget genérico (dashboard)
  form_category: 'Form Category',
  form: 'Form',
  filter: 'Filter',
  filter_action: 'Filter',
  clear_filters: 'Clear Filters',
  filter_elements: 'Filter items',
  write_here: 'Type here',
  duplicate: 'Duplicate',
  rename: 'Rename',

  // Metadatos y campos de ítems (occurrences/reportes)
  task_priority: 'Priority: ',
  priority: 'Priority',
  description: 'Description',
  comment: 'Comment',
  title: 'Title',
  category: 'Category',
  score: 'Rating',
  incidences: 'Incidents',
  without_result: 'Found no results',
  option: 'Option',
  value: 'Value',

  // Acciones y mensajes puntuales
  add_camp: 'Add Campaign',
  back_event: 'Back',
  close: 'Close',
  irreversible_action: 'Irreversible action',
  search: 'Search',
  since: 'From',
  organization_name: 'Name of the organization',

  // Agenda / eventos (probable residuo de la migración a calendar.js)
  event_user: 'Per User',
  event_organization: 'The Whole Organization',
  event_guest: 'Add Guests',
  event_notification: 'Send Notification',
  event_desc: 'Description',
  tittle_event: 'Title of the Event',
  allday: 'All day',
  event_perday: 'Create one Event per day',
  event_range: 'Ranks',
  event_break: 'Rest',
  eventSt: 'Event',
  week_beginning: 'Start of the week',
  week_number: 'Show week number',

  // Tareas: orden y estado
  expired: 'Expired',
  add_task: 'Add Task',
  asc: 'Ascendant',
  leftday: 'Remaining days ',
  creation: 'Creation',
  priory: 'Priority',
  orderby: 'Sort by:',
  donetasks: 'View completed tasks',
  byme: 'Assigned by me',
  suspended: 'Suspended',
  done: 'Completed',
  notdone: 'To be done',

  // Textos sueltos sin agrupación clara
  desc: 'Descending',
  average: 'Average',
  audit: 'Audits',
  evidence: 'Evidence:',
  add_coment: 'Add your comment',
  select_location: 'Select a Location',
  task_create: 'Created by me',
  more: 'More',
  plans: 'Plans',
  to_assign: 'Send to the Auditee',
  'save-and-close': 'Save and Close',
  'rows-per-page-label': 'Records per page',
  all_available: 'All available',
  options: 'Options',
  values: 'Values'
}
